var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame37({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 0.00000104907,
    width: 24,
    height: 24,
    rx: 5,
    transform: "rotate(90 24 1.04907e-06)",
    fill: "#101111",
    fillOpacity: 0.804
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 16L12 8L6 16L18 16Z",
    fill: "#23484E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame37);
export default __webpack_public_path__ + "static/media/Frame 37.7e31406e6744aa0318ab7eed51e9dc42.svg";
export { ForwardRef as ReactComponent };